import { render, staticRenderFns } from "./NoMoving.vue?vue&type=template&id=c48f8a96&scoped=true"
import script from "./NoMoving.vue?vue&type=script&lang=js"
export * from "./NoMoving.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c48f8a96",
  null
  
)

export default component.exports